"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Compare = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _BrowserStorage = _interopRequireDefault(require("acq-utils/lib/BrowserStorage"));
var _CardPicker = require("../CardPicker/CardPicker");
var _CompareList = require("../CompareList/CompareList");
var _CompareSection = require("./CompareSection");
var _CompareStickyBar = require("../CompareStickyBar/CompareStickyBar");
var _ScrollActivator = require("../../utils/ScrollActivator/ScrollActivator");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Compare = exports.Compare = /*#__PURE__*/function (_React$Component) {
  _inherits(Compare, _React$Component);
  var _super = _createSuper(Compare);
  function Compare(props) {
    var _this;
    _classCallCheck(this, Compare);
    _this = _super.call(this, props);
    _defineProperty(_assertThisInitialized(_this), "onLearnMore", function (card) {
      var onLearnMore = _this.props.onLearnMore;
      if (typeof onLearnMore === 'function') {
        onLearnMore(card);
      }
    });
    _defineProperty(_assertThisInitialized(_this), "shouldStick", function () {
      var _this$compareListPosi = _this.compareListPosition.getBoundingClientRect(),
        top = _this$compareListPosi.top,
        height = _this$compareListPosi.height;
      if (window.pageYOffset > top + height / 2) {
        _this.setState({
          showStickyBar: true
        });
      } else {
        _this.setState({
          showStickyBar: false
        });
      }
    });
    _defineProperty(_assertThisInitialized(_this), "buildSectionizedWrap", function (compareList) {
      if (_this.props.isFullWidthBackgroundMode) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: "compareListWrap"
        }, compareList);
      }
      return compareList;
    });
    _defineProperty(_assertThisInitialized(_this), "selectCard", function (card) {
      var activeCards = _this.state.activeCards;
      var onAddCard = _this.props.onAddCard;
      if (onAddCard) {
        onAddCard(card);
      }
      var newActiveCards = [].concat(_toConsumableArray(activeCards), [card]);
      var newActiveCardsShortNames = newActiveCards.map(function (activeCard) {
        return activeCard.shortName;
      });
      _this.storage.set(newActiveCardsShortNames);
      _this.setState({
        activeCards: newActiveCards,
        showCardPicker: false
      });
    });
    _defineProperty(_assertThisInitialized(_this), "removeCard", function (card) {
      var activeCards = _this.state.activeCards;
      var onRemoveCard = _this.props.onRemoveCard;
      if (typeof onRemoveCard === 'function') {
        onRemoveCard(card);
      }
      var cardsToKeep = activeCards.filter(function (activeCard) {
        return activeCard.shortName !== card.shortName;
      });
      _this.storage.set(cardsToKeep.map(function (c) {
        return c.shortName;
      }));
      _this.setState({
        activeCards: cardsToKeep
      });
    });
    _defineProperty(_assertThisInitialized(_this), "toggleCardPicker", function () {
      var showCardPicker = _this.state.showCardPicker;
      var _this$props = _this.props,
        onAddCard = _this$props.onAddCard,
        onCloseCardPicker = _this$props.onCloseCardPicker;
      if (showCardPicker === true && typeof onCloseCardPicker === 'function') {
        onCloseCardPicker();
      }
      if (showCardPicker === false && typeof onAddCard === 'function') {
        onAddCard();
      }
      _this.setState({
        showCardPicker: !showCardPicker
      });
    });
    _this.state = {
      showCardPicker: false,
      showStickyBar: false,
      activeCards: []
    };
    _this.storage = (0, _BrowserStorage["default"])().bindItem('compareCards');
    return _this;
  }
  _createClass(Compare, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props2 = this.props,
        cardsData = _this$props2.cards,
        preFilledCards = _this$props2.preFilledCards;
      var storageCards = this.storage.get() || [];
      var cardsToUse = storageCards.length > 0 ? storageCards : preFilledCards;
      var activeCards = cardsData.filter(function (card) {
        return cardsToUse.includes(card.shortName);
      });
      this.compareListPosition = document.querySelector('.compare-list');
      this.setState({
        activeCards: activeCards
      }); // eslint-disable-line react/no-did-mount-set-state
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var _this$state = this.state,
        showCardPicker = _this$state.showCardPicker,
        showStickyBar = _this$state.showStickyBar,
        activeCards = _this$state.activeCards;
      var _this$props3 = this.props,
        cards = _this$props3.cards,
        labels = _this$props3.labels,
        styles = _this$props3.styles,
        maxNumOfCards = _this$props3.maxNumOfCards,
        className = _this$props3.className,
        namespace = _this$props3.namespace,
        annualFeeLabel = _this$props3.annualFeeLabel,
        cardPickerDismissDtm = _this$props3.cardPickerDismissDtm,
        addCardDtm = _this$props3.addCardDtm,
        isFullWidthBackgroundMode = _this$props3.isFullWidthBackgroundMode,
        addCardText = _this$props3.addCardText,
        cardPickerHeaderText = _this$props3.cardPickerHeaderText,
        linkComponent = _this$props3.linkComponent;
      var classNames = (0, _classnames["default"])('compare', className, styles.compareStyles.compare, {
        sectionizedFullBackground: isFullWidthBackgroundMode
      });
      var compareList = /*#__PURE__*/_react["default"].createElement(_CompareList.CompareList, {
        namespace: namespace,
        styles: styles.compareListStyles,
        cards: activeCards,
        annualFeeLabel: annualFeeLabel,
        addCard: this.toggleCardPicker,
        removeCard: this.removeCard,
        onLearnMore: this.onLearnMore,
        addCardDtm: addCardDtm,
        columnCount: maxNumOfCards,
        addCardText: addCardText,
        linkComponent: linkComponent
      });
      return /*#__PURE__*/_react["default"].createElement(_ScrollActivator.ScrollActivator, {
        onScroll: this.shouldStick
      }, function () {
        return /*#__PURE__*/_react["default"].createElement("div", {
          className: classNames
        }, _this2.buildSectionizedWrap(compareList), labels.map(function (label, index) {
          var key = "key-".concat(index);
          return /*#__PURE__*/_react["default"].createElement(_CompareSection.CompareSection, {
            namespace: namespace,
            activeCards: activeCards,
            maxNumOfCards: maxNumOfCards,
            identifier: label.identifier,
            title: label.text,
            key: key
          });
        }), showCardPicker && /*#__PURE__*/_react["default"].createElement(_CardPicker.CardPicker, {
          namespace: namespace,
          styles: styles.cardPickerStyles,
          cards: cards,
          onExit: _this2.toggleCardPicker,
          onPick: _this2.selectCard,
          selected: activeCards,
          dtm: cardPickerDismissDtm,
          headerText: cardPickerHeaderText
        }), showStickyBar && /*#__PURE__*/_react["default"].createElement(_CompareStickyBar.CompareStickyBar, {
          activeCards: activeCards,
          addCard: _this2.toggleCardPicker,
          addCardDtm: addCardDtm,
          addCardText: addCardText,
          columnCount: maxNumOfCards,
          namespace: 'compare-sticky-bar',
          removeCard: _this2.removeCard,
          styles: styles.compareStickyBarStyles,
          linkComponent: linkComponent
        }));
      });
    }
  }]);
  return Compare;
}(_react["default"].Component);
Compare.propTypes = {
  cards: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    assets: _propTypes["default"].arrayOf(_propTypes["default"].shape({
      type: _propTypes["default"].string,
      url: _propTypes["default"].string
    })),
    cardFeatures: _propTypes["default"].shape({
      content: _propTypes["default"].arrayOf(_propTypes["default"].shape({
        key: _propTypes["default"].string,
        desc: _propTypes["default"].arrayOf(_propTypes["default"].shape({
          type: _propTypes["default"].oneOf(['TEXT', 'LIST']),
          text: _propTypes["default"].string,
          content: _propTypes["default"].arrayOf(_propTypes["default"].shape({
            type: _propTypes["default"].string,
            text: _propTypes["default"].string
          }))
        })),
        links: _propTypes["default"].arrayOf(_propTypes["default"].shape({
          dtm: _propTypes["default"].shape({
            eventAction: _propTypes["default"].string,
            eventAsset: _propTypes["default"].string
          })
        }))
      }))
    }),
    cardTitle: _propTypes["default"].string,
    shortName: _propTypes["default"].string
  })).isRequired,
  className: _propTypes["default"].string,
  maxNumOfCards: _propTypes["default"].number,
  isFullWidthBackgroundMode: _propTypes["default"].bool,
  labels: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    identifier: _propTypes["default"].string.isRequired,
    text: _propTypes["default"].string.isRequired
  })).isRequired,
  styles: _propTypes["default"].shape({
    cardPickerStyles: _propTypes["default"].object.isRequired,
    compareStyles: _propTypes["default"].shape({
      compare: _propTypes["default"].string
    }).isRequired,
    compareListStyles: _propTypes["default"].object.isRequired
  }),
  namespace: _propTypes["default"].string,
  annualFeeLabel: _propTypes["default"].string,
  cardPickerDismissDtm: _propTypes["default"].objectOf(_propTypes["default"].string),
  addCardDtm: _propTypes["default"].objectOf(_propTypes["default"].string),
  addCardText: _propTypes["default"].string,
  cardPickerHeaderText: _propTypes["default"].string,
  onAddCard: _propTypes["default"].func,
  onCloseCardPicker: _propTypes["default"].func,
  onLearnMore: _propTypes["default"].func,
  onRemoveCard: _propTypes["default"].func,
  linkComponent: _propTypes["default"].func,
  preFilledCards: _propTypes["default"].arrayOf(_propTypes["default"].string)
};
Compare.defaultProps = {
  namespace: '',
  className: '',
  maxNumOfCards: 3,
  isFullWidthBackgroundMode: false,
  styles: {
    cardPickerStyles: {},
    compareStyles: {},
    compareListStyles: {},
    compareStickyBarStyles: {}
  },
  annualFeeLabel: undefined,
  cardPickerDismissDtm: {},
  addCardDtm: {},
  addCardText: undefined,
  onAddCard: undefined,
  onCloseCardPicker: undefined,
  onRemoveCard: undefined,
  onLearnMore: undefined,
  cardPickerHeaderText: undefined,
  linkComponent: undefined,
  preFilledCards: []
};